import { IMultipartFormData } from '../services/MultipartFormData.data';
import { AssetType } from './DashboardModels';

export interface ICreateAccountPayload {
  accountName: string;
  projectName: string;
}

export interface IAddAccountPayload {
  accountName: string;
  wbs_code: string;
  account_owner: string;
  owner_email: string;
  usecase: string;
  userId: string;
}

export enum ProjectStatus {
  ACTIVE = 'Active',
  SUSPENDED = 'Suspended',
}
export interface IEditProjectPayload {
  projectName?: string;
  projectStatus?: ProjectStatus;
  projectId: string;
}
export interface ICreateProjectPayload extends ICreateAccountPayload {
  accountId: string;
  userId: string;
}
export interface ISelectProjectPayload {
  projectName: string;
  projectId: string;
}

export interface ISelectAccountPayload {
  assetType: AssetType;
  accountName: string;
  accountId: string;
}

export interface IPinAccountPayload {
  accountId: string;
  action: string;
}
